// useGreenFeeCalculator.js
import { useCallback } from 'react';
import moment from 'moment';
import { getDynamicPricingAmount } from '../../../api/teeTimeAPI';

export const useGreenFeeCalculator = ({ 
  greenFeeMasterList,
  setGreenFeeList,
  setBookingUsersAndRateDetails
  // updateBookingDetails,
  // setRateDetails,
  // setBookingUsers,
}) => {
  const isWeekendDate = (date, holiday) => {
    const day = moment(date, 'DD-MM-YYYY').day();
    return (day === 6 || day === 0 || holiday !== null) ? 'Y' : 'N';
  };

  const validateUsers = (userList, selectedDate, isWeekend) => {   
    return userList.map(user => {
      const bookDate               = moment(selectedDate, 'DD-MM-YYYY');
      const isSubscriptionExpired = (!user?.SubscriptionExpiresOn || (user.SubscriptionExpiresOn && moment(user.SubscriptionExpiresOn).isBefore(bookDate)));  /**@todo - True if null */
      const isMembershipExpired   = (!user?.MembershipExpiresOn || (user.MembershipExpiresOn && moment(user.MembershipExpiresOn).isBefore(bookDate)));
      const isWeekendRestriction  = user.SubCategoryID === 7 && isWeekend === 'Y';

      let isValid = !(isSubscriptionExpired || isMembershipExpired || isWeekendRestriction);

      if (user.SubCategoryID === 3 || user.SubCategoryID === 5) {
        isValid = false;
      }     

      return {
        ...user,
        IsValidMember: isValid ? 'Y' : 'N'
      };
    });
  };

  const forceCartAndCaddyForGuests = (userList) => {
    return userList.map(user => {
      if (user.IsValidMember === 'N') {
        return {
          ...user,
          IsCartRequired: 'Y',
          IsCaddyRequired: 'Y',
          IsCartUpdated: true
        };
      }
      return user;
    });
  };

  const createSubCategoryList = (userList) => {   
    return userList.map(u => ({
      userID: u.UserID,
      subID: u.SubCategoryID,
      IsValidMember: u.IsValidMember === 'Y',
      IsCartRequired: u.IsCartRequired === 'Y',
      IsCaddyRequired: u.IsCaddyRequired === 'Y',
      couponCode: u.couponCode
    }));
  };

  const matchGreenFees = (subCatList, effectiveHole, isWeekend, membersGuestFee, walkinGuestFee) => {   
    const matchedFees = [];
    greenFeeMasterList.forEach(fee => {   
      if (fee.IsWeekend === isWeekend && fee.Hole == parseInt(effectiveHole)) {      
        subCatList.forEach(user => {
          // console.log('user', user);
          if (user.subID === fee.SubCategoryID || (user.subID === 7 && fee.SubCategoryID === 1)) {        
            if ([1, 2, 7].includes(user.subID)) {              
              matchedFees.push({ subCat: user, greenFee: user.IsValidMember ? fee : (subCatList[0].IsValidMember ? membersGuestFee : walkinGuestFee) });
            } else if (user.subID === 5) {
              matchedFees.push({ subCat: user, greenFee: subCatList[0].IsValidMember ? fee : walkinGuestFee });
            } else {
              matchedFees.push({ subCat: user, greenFee: fee });
            }
          }
        });
      }
    });
    return matchedFees;
  };

/**
 * applyCartSharingLogic(users)
 *  users: array of user objects:
 *  IsCartRequired, IsCaddyRequired, IsValidMember, SubCategoryID, IsCartUpdated
 *  USE e.isToggleDisabled = boolean to enable/disable toggle
 *  USE IsCartUpdated to enable forced toggle - boolean
 * Returns: { updatedUsers, memberShareCount }
 *
 */


const applyCartSharingLogic = (users) => {
  const updatedUsers = users.slice();

  // Ensure defaults
  updatedUsers.forEach(u => {
    if (u.IsCartRequired === undefined) u.IsCartRequired = "N";
    if (u.IsCaddyRequired === undefined) u.IsCaddyRequired = "N";
    if (u.IsValidMember === undefined) u.IsValidMember = "Y";
    if (u.SubCategoryID === undefined) u.SubCategoryID = 1;
    if (u.IsCartUpdated === undefined) u.IsCartUpdated = false;
    u.isToggleDisabled = false; // default enabled
  });

  let memberShareCount = 0;
  const len = updatedUsers.length;

  // CASE: single user
  if (len === 1) {
    updatedUsers[0].IsCartRequired = "Y";
    updatedUsers[0].IsCaddyRequired = "Y";
    updatedUsers[0].isToggleDisabled = true;
    return { updatedUsers, memberShareCount };
  }

  // CASE: 2-3 players
  if (len < 4) {
    let memberCount = 0;
    let residentialMemberCount = 0;
    let guestCount = 0;
    let uncheckCount = 0;
    let residentUncheckCount = 0;
    let uncheckIndex = 5;
    let residentUncheckIndex = 5;

    updatedUsers.forEach((e) => {
      if (e.IsValidMember == "N") {
        e.IsCartRequired = "Y";
        e.IsCaddyRequired = "Y";
        e.isToggleDisabled = true;
      }
      if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") memberCount++;
      if (e.SubCategoryID == 2 && e.IsValidMember == "Y") residentialMemberCount++;
      if (e.IsValidMember == "N") guestCount++;
    });

    const updateUncheck = () => {
      uncheckCount = 0;
      residentUncheckCount = 0;
      uncheckIndex = 5;
      residentUncheckIndex = 5;
      updatedUsers.forEach((element, index) => {
        if (element.IsCartRequired == "N") {
          uncheckCount++;
          uncheckIndex = index;
          if (element.SubCategoryID == 2) {
            residentUncheckCount++;
            residentUncheckIndex = index;
          }
        }
      });
    };

    updatedUsers.forEach((e, i) => {
      updateUncheck();

      if ((memberCount == residentialMemberCount) && (memberCount == guestCount)) {
        if (e.SubCategoryID == 2) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          updateUncheck();
        } else if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          updateUncheck();
        }
      } else if ((memberCount == residentialMemberCount || guestCount == residentialMemberCount) && residentialMemberCount > 0) {
        if (e.SubCategoryID == 1 || e.SubCategoryID == 7) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          updateUncheck();
        } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          updateUncheck();
        }
      } else if (memberCount == guestCount && memberCount > 0) {
        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          updateUncheck();
        }
      } else if (residentialMemberCount == 2 && memberCount > 0) {
        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) || (e.SubCategoryID == 2 && residentUncheckCount > 0 && i != residentUncheckIndex)) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          updateUncheck();
        } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "Y" && uncheckCount == 0) {
          if (!e.IsCartUpdated) {
            e.IsCartRequired = "N";
            e.IsCaddyRequired = "N";
            updateUncheck();
          }
          e.isToggleDisabled = false;
        }
      } else if (memberCount == 2 && residentialMemberCount > 0) {
        if (e.SubCategoryID == 2 || ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && uncheckCount > 0 && i != uncheckIndex && updatedUsers[uncheckIndex].SubCategoryID != 2)) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          updateUncheck();
        } else if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && e.IsCartRequired == "Y" && uncheckCount == 0) {
          if (!e.IsCartUpdated) {
            e.IsCartRequired = "N";
            e.IsCaddyRequired = "N";
            updateUncheck();
          }
          e.isToggleDisabled = false;
        }
      } else if (memberCount > 1 && uncheckCount == 0) {
        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
          e.isToggleDisabled = false;
        }
      } else if (residentialMemberCount > 1 && uncheckCount == 0) {
        if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
          e.isToggleDisabled = false;
        }
      } else if (i != uncheckIndex && uncheckCount > 0) {
        e.IsCartRequired = "Y";
        e.IsCaddyRequired = "Y";
        e.isToggleDisabled = true;
        updateUncheck();
      }

      updatedUsers.forEach(function (ee) {
        if (residentialMemberCount > 0 && memberCount > 0 && guestCount == 0 && uncheckCount == 1 && ee.SubCategoryID == 2 && ee.IsValidMember == "Y" && ee.IsCartRequired == "N")
          memberShareCount = 1;
      });
    });

    return { updatedUsers, memberShareCount };
  }

  // CASE: 4+ players
  {
    let uncheckCount = 0;
    let residentUncheckCount = 0;
    let residentUncheckIndex1 = 5;
    let residentUncheckIndex2 = 5;
    let uncheckIndex1 = 5;
    let uncheckIndex2 = 5;
    let memberCount = 0;
    let residentialMemberCount = 0;
    let guestCount = 0;
    let isMemberShared = false;
    let isResidentialShared = false;

    updatedUsers.forEach((e) => {
      if (e.IsValidMember == "N") {
        e.IsCartRequired = "Y";
        e.IsCaddyRequired = "Y";
        e.isToggleDisabled = true;
      }
      if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") memberCount++;
      if (e.SubCategoryID == 2 && e.IsValidMember == "Y") residentialMemberCount++;
      if (e.IsValidMember == "N") guestCount++;
    });

    const updateUncheck = () => {
      uncheckCount = 0;
      residentUncheckCount = 0;
      uncheckIndex1 = 5;
      uncheckIndex2 = 5;
      residentUncheckIndex1 = 5;
      residentUncheckIndex2 = 5;
      updatedUsers.forEach((element, index) => {
        if (element.IsCartRequired == "N") {
          uncheckCount++;
          if (uncheckCount == 1) uncheckIndex1 = index;
          if (uncheckCount > 1) uncheckIndex2 = index;
          if (element.SubCategoryID == 2) {
            residentUncheckCount++;
            if (residentUncheckCount == 1) residentUncheckIndex1 = index;
            if (residentUncheckCount > 1) residentUncheckIndex2 = index;
          }
        }
      });
    };

    updatedUsers.forEach((e, i) => {
      updateUncheck();

      if (guestCount > 1) {
        if (e.IsValidMember == "Y" && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          updateUncheck();
        }
      } else if (residentialMemberCount == memberCount && residentialMemberCount == 2) {
        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7)) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          updateUncheck();
        } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          updateUncheck();
        }

        if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N")
          memberShareCount++;
      } else if (guestCount == memberCount && memberCount > 0) {
        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          updateUncheck();
        } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && !e.IsCartUpdated) {
          if (isResidentialShared) {
            e.IsCartRequired = "Y";
            e.IsCaddyRequired = "Y";
            e.isToggleDisabled = true;
          } else {
            e.IsCartRequired = "N";
            e.IsCaddyRequired = "N";
            e.isToggleDisabled = false;
            isResidentialShared = true;
          }
          updateUncheck();
        } else if (uncheckCount < 2 && (e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
          e.isToggleDisabled = false;
        }
      } else if (memberCount == 2 || (memberCount == 3 && residentialMemberCount == 1)) {
        const cond1 = (updatedUsers[uncheckIndex1] && (updatedUsers[uncheckIndex1].SubCategoryID == 1 || updatedUsers[uncheckIndex1].SubCategoryID == 7) && updatedUsers[uncheckIndex1].IsCartRequired == "N" && i != uncheckIndex1);
        const cond2 = (updatedUsers[uncheckIndex2] && (updatedUsers[uncheckIndex2].SubCategoryID == 1 || updatedUsers[uncheckIndex2].SubCategoryID == 7) && updatedUsers[uncheckIndex2].IsCartRequired == "N" && i != uncheckIndex2);

        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && (cond1 || cond2)) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          updateUncheck();
        } else if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !isMemberShared && !e.IsCartUpdated) {
          e.IsCartRequired = "N";
          e.IsCaddyRequired = "N";
          e.isToggleDisabled = false;
          isMemberShared = true;
          updateUncheck();
        } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
          e.isToggleDisabled = false;
        }

        if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N")
          memberShareCount++;
      } else if (memberCount > 2 && uncheckCount < 2) {
        if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
          e.isToggleDisabled = false;
        }
      } else if (residentialMemberCount > 2) {
        if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
          if (residentUncheckCount < 2) {
            if (e.IsCartUpdated) {
              e.isToggleDisabled = false;
            } else {
              e.IsCartRequired = "N";
              e.IsCaddyRequired = "N";
              e.isToggleDisabled = false;
              updateUncheck();
            }
          } else if (i != residentUncheckIndex1 && i != residentUncheckIndex2 && residentUncheckCount > 1) {
            e.IsCartRequired = "Y";
            e.IsCaddyRequired = "Y";
            e.isToggleDisabled = true;
            updateUncheck();
          }
        } else if (e.SubCategoryID == 1 || e.SubCategoryID == 7) {
          e.IsCartRequired = "Y";
          e.IsCaddyRequired = "Y";
          e.isToggleDisabled = true;
          memberShareCount++;
          updateUncheck();
        }
      } else if (i != uncheckIndex1 && i != uncheckIndex2 && uncheckCount > 1) {
        e.IsCartRequired = "Y";
        e.IsCaddyRequired = "Y";
        e.isToggleDisabled = true;
        updateUncheck();
      }
    });

    updatedUsers.forEach(function (e) {
      if (residentialMemberCount > 0 && memberCount > 0 && guestCount > 0 && uncheckCount == 1 && e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N")
        memberShareCount = 1;
    });

    return { updatedUsers, memberShareCount };
  }
};


const calculateGreenFee = useCallback(async (
    hole,
    selectedDate,
    userList,
    ReferenceID = 0,
    holiday = null,
    discountPercentage = 0,
    bookingUsers,
    action = 'addUser',
    templateId = null,
) => {

    const isWeekend     = isWeekendDate(selectedDate, holiday);
    const effectiveHole = isWeekend === 'Y' ? 18 : hole;    

    const membersGuestFee = greenFeeMasterList.find(i => i.SubCategoryID === 5 && i.Hole == effectiveHole && i.IsWeekend === isWeekend);
    const walkinGuestFee = greenFeeMasterList.find(i => i.SubCategoryID === 3 && i.Hole == effectiveHole && i.IsWeekend === isWeekend);

    // Users Whos GreenFee is Already Calculated --
    const processedIDs  = new Set(userList.map(u => `${u.UserID}_${u.UserType}`));
    const unchanged = bookingUsers.filter( u => !processedIDs.has(`${u.UserID}_${u.UserType}`));
    
    // console.log('newUserList', userList);

    let newUserList = [...userList];   
  
    // if(action != "removeUser") newUserList = [...unchanged, ...userList];
  
    //Adds Valid / Invalid Flag --
    let greenFeeCalculatedUsers = validateUsers(newUserList, selectedDate, isWeekend);

    //Adds Cart & Caddy Flag --
    greenFeeCalculatedUsers = forceCartAndCaddyForGuests(greenFeeCalculatedUsers);

    //Add cart sharing logic here if necessary
    const { updatedUsers: usersAfterSharing, memberShareCount } = applyCartSharingLogic(greenFeeCalculatedUsers);
    greenFeeCalculatedUsers = usersAfterSharing;
      
    const subCatList = createSubCategoryList(greenFeeCalculatedUsers);
    const greenFeeList = matchGreenFees(subCatList, effectiveHole, isWeekend, membersGuestFee, walkinGuestFee);
  
    //Check ITS USE
    setGreenFeeList(greenFeeList.map(item => ({ ...item.greenFee, UserID: item.subCat.userID })));

    let totalGreenFee = 0, totalCartFee = 0, totalCaddyFee = 0, cartCount = 0, caddyCount = 0;
  
    greenFeeList.forEach(({ subCat, greenFee }) => {
      // console.log('greenFee', greenFee, subCat);
      if (subCat.subID != 5 || !Boolean(subCat.couponCode)) {        
        totalGreenFee += greenFee.GreenFee;
      }
      if (subCat.IsCartRequired) {
        totalCartFee += greenFee.Cart;
        cartCount++;
      }
      if (subCat.IsCaddyRequired) {
        totalCaddyFee += greenFee.Caddy;
        caddyCount++;
      }
    });

    let totalAmount = totalGreenFee + totalCartFee + totalCaddyFee;

    // Dynamic Pricing -- applied to Cart Fee + Caddy Fee ONLY, before the
    // member-share/admin discount below, which then applies on top of this
    // dynamically-discounted total. GreenFee is deliberately excluded -- it's
    // always charged in full, the discount never touches it. Read-only
    // preview: a lookup failure never blocks the rest of the calculation.
    let dpCalendarId = null, dpCalendarName = null, dpDiscountAmount = 0, dpDiscountType = null, dpDiscountValue = null;
    const cartCaddyAmount = totalCartFee + totalCaddyFee;
    if (templateId && selectedDate && cartCaddyAmount > 0) {
      const bookingDate = moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
      const dynamicPricing = await getDynamicPricingAmount(templateId, bookingDate, cartCaddyAmount, effectiveHole);
      if (dynamicPricing?.discountAmount > 0) {
        totalAmount -= dynamicPricing.discountAmount;
        dpCalendarId = dynamicPricing.calendarId;
        dpCalendarName = dynamicPricing.name;
        dpDiscountAmount = dynamicPricing.discountAmount;
        dpDiscountType = dynamicPricing.discountType;
        dpDiscountValue = dynamicPricing.discountValue;
      }
    }

    let discountAmount = 0, adminDiscountAmount = 0;

    // Member share discount
    if (memberShareCount > 0 && ReferenceID == 0) {    
      const memberGreenFee = greenFeeMasterList.find(i => 
        i.SubCategoryID == 1 && 
        i.Hole == effectiveHole && 
        i.IsWeekend == isWeekend
      );

      const shareDiscount = (memberGreenFee?.Cart + memberGreenFee?.Caddy) / 2;
      discountAmount = shareDiscount * memberShareCount;
      // Discount = Math.round(((discountAmount / totalAmount) * 100) + discountPercentage);
    } 
    
    //Reference Discount
    if (ReferenceID != 0) discountAmount = (totalAmount * discountPercentage) / 100;
  
 
    totalAmount -= discountAmount;

    //Admin Discount
    if (ReferenceID == 0) {
      adminDiscountAmount = (totalAmount * discountPercentage) / 100;
      totalAmount -= adminDiscountAmount;
    }
        
    const tax         = totalAmount * 0.18;
    const finalAmount = totalAmount + tax;
      
    //Check if this is necessary - 
    // updateBookingDetails('MemberShareCount', memberShareCount > 0, ReferenceID);      
        
    // console.log("UpdatedList After Calculation", greenFeeCalculatedUsers);

    /**@DESC - Combine OLD Unchanged User And New Calculated USERS */
    const allGroupUsers = [...unchanged, ...greenFeeCalculatedUsers]

    // console.log('allGroupUsers', allGroupUsers);

    
    const [{ TeeTimeBookID: teeBookID } = {}] = greenFeeCalculatedUsers;

    setBookingUsersAndRateDetails({
      rateDetails : new Map([
        [teeBookID, {
          GreenFee  : totalGreenFee,
          NoOfCart  : cartCount,
          NoOfCaddy : caddyCount,
          CartFee   : totalCartFee.toFixed(2),
          CaddyFee  : totalCaddyFee.toFixed(2),
          Discount  : (discountAmount + adminDiscountAmount).toFixed(2),
          Sgst      : (tax / 2).toFixed(2),
          Cgst      : (tax / 2).toFixed(2),
          Total     : Math.round(finalAmount),
          ShowGreenFee : totalGreenFee > 0,
          ShowCart      : cartCount > 0,
          ShowCaddy     : caddyCount > 0,
          ShowDiscount: discountAmount > 0 || adminDiscountAmount > 0,
          DiscountPercent : Math.round((discountAmount + adminDiscountAmount) / parseFloat(totalAmount + discountAmount + adminDiscountAmount ) * 100),
          DynamicPricingCalendarID   : dpCalendarId,
          DynamicPricingCalendarName: dpCalendarName,
          DynamicDiscountAmount      : dpDiscountAmount.toFixed(2),
          DynamicDiscountType        : dpDiscountType,
          DynamicDiscountValue       : dpDiscountValue,
          ShowDynamicDiscount        : dpDiscountAmount > 0
        }]
      ]),
      // bookingUsers : newUserList
      // bookingUsers : greenFeeCalculatedUsers
      bookingUsers : allGroupUsers
    });

    //Eliminated - with single update action creator 
    // setRateDetails({
    //   GreenFee: totalGreenFee,
    //   NoOfCart: cartCount,
    //   NoOfCaddy: caddyCount,
    //   CartFee: totalCartFee.toFixed(2),
    //   CaddyFee: totalCaddyFee.toFixed(2),
    //   Discount: (discountAmount + adminDiscountAmount).toFixed(2),
    //   Sgst: (tax / 2).toFixed(2),
    //   Cgst: (tax / 2).toFixed(2),
    //   Total: Math.round(finalAmount),
    //   ShowGreenFee: totalGreenFee > 0,
    //   ShowCart: cartCount > 0,
    //   ShowCaddy: caddyCount > 0,
    //   ShowDiscount: discountAmount > 0 || adminDiscountAmount > 0
    // });

    // setBookingUsers(prev => {
    //   const processedIDs = new Set(updatedUserList.map(u => u.UserID));
    //   const unchanged = prev.filter(u => !processedIDs.has(u.UserID));
    //   return [...unchanged, ...updatedUserList];
    // });
  }, [greenFeeMasterList]);

  return { calculateGreenFee };
};

